export class Model {

  constructor(options) {
    Object.keys(options).forEach(key => {
      this[key.camelCase()] = options[key]
    });
  }
}